const OPEN_CUSTOMER_PREFIX = '/open-customer';

const PATH_PREFIX_MAP = [OPEN_CUSTOMER_PREFIX];

export const ECATALOGUE_STORAGE_KEYS = {
  CART: 'product-cart',
  STORE: 'storeData',
  ORDERS: 'orders',
  CUSTOMER_MOBILE: 'customer-mobile'
};

export function getECatalogueRoutePrefix(route, explicitPrefix = '') {
  if (explicitPrefix) {
    return explicitPrefix;
  }

  if (route?.meta?.routePrefix) {
    return route.meta.routePrefix;
  }

  const routePath = route?.path || '';
  const matchedPrefix = PATH_PREFIX_MAP.find(prefix => routePath === prefix || routePath.startsWith(`${prefix}/`));
  return matchedPrefix || '';
}

export function getECatalogueStorageKey(route, key, explicitPrefix = '') {
  const prefix = getECatalogueRoutePrefix(route, explicitPrefix);
  return prefix ? `${prefix}:${key}` : key;
}
